import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Logout from "modules/auth/logout/pages/Logout";
import { ProfileIcon, UserTickIcon } from "assets";
import { SmallScreenModel } from "components";
import HandleNameChange from "modules/auth/users/pages/manage_user/HandleNameChange";

const NavDropDown: React.FC<any> = () => {
  const user = useSelector((state: any) => state.auth.authState.authUser?.user);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const redirectToProfile = () => {
    navigate("/profile");
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex w-1/5 justify-end mx-4" ref={dropdownRef}>
      <div className="content-center relative">
        <div
          className="flex h-8 w-8 bg-primary-600 rounded-full items-center justify-center cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <p className="text-xl font-bold text-white">
            {user?.name?.toUpperCase().charAt(0) || "U"}
          </p>
        </div>
        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200">
            <p className="px-4 py-2 text-xs text-gray-700 font-light flex items-center">
              <UserTickIcon />
              Signed in as:
            </p>
            <p className="px-4 py-1 text-xs text-gray-700 font-light">
              <span className="text-black font-bold">
                {user?.email || "abc@abc.bt"}
              </span>
            </p>
            <hr className="my-1 border-t border-gray-500" />

            <p className="px-4 py-2 text-sm font-medium text-gray-900 flex items-center border-b border-gray-300">
              <ProfileIcon className="h-4 w-4 text-primary-500 mr-1" />
              {user?.name || "User"}
            </p>

            <button
              className="w-full flex items-center text-left px-4 py-2 text-sm text-gray-900 font-medium hover:bg-gray-100 justify-start border-b border-gray-300"
              onClick={redirectToProfile}
            >
              <ProfileIcon className="h-4 w-4 text-primary-500 mr-1" />
              Profile
            </button>
            <button
              className="w-full flex items-center text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 border-b border-gray-300"
              onClick={openModal}
            >
              <ProfileIcon className="h-4 w-4 text-primary-500 mr-1" />
              Rename Account
            </button>
            {isModalOpen && (
              <SmallScreenModel
                showModal={isModalOpen}
                setShowModal={setIsModalOpen}
              >
                <HandleNameChange closeModal={setIsModalOpen} userData={user} />
              </SmallScreenModel>
            )}
            <Logout />
          </div>
        )}
      </div>
    </div>
  );
};

export default NavDropDown;
